module.exports = __webpack_public_path__ + "giving/public/shared/assets/jcb.svg?4517d1136ddd6aad9353104e587ca2e6";